// src/lib/groModelImport.ts
export const GRO_MODEL_IMPORT_ITEMS = [
  "Riscos ativos",
  "Dimensões ativas",
  "Relacionamentos Dimensões x Riscos ativos",
  "Planos de Ação modelo ativos",
  "Ações ativas dos Planos de Ação",
  "Relacionamentos Riscos x Planos de Ação",
  "Planos de Ação recomendados por regra Dimensão x Risco",
] as const;

export const GRO_IMPORT_SUMMARY_LABELS: Record<string, string> = {
  risks: "Riscos",
  dimensions: "Dimensões",
  dimension_risk_rules: "Dimensões x Riscos",
  action_plan_models: "Planos de Ação",
  action_plan_model_items: "Ações dos Planos",
  risk_action_plan_models: "Riscos x Planos de Ação",
  dimension_risk_rule_action_plan_models: "Planos recomendados por regra",
};
